// Slots gate (docs/ADS-PLUMBING.md 2.1). The only slot code in the app bundle: on the first real
// interaction, and only while Settings "Show ads" is on and the first-run welcome is closed, it
// fetches this host's slot config once and, unless slots are off here, imports the lazy slots
// bundle. A Lighthouse run never interacts, so it never loads any of it. With the setting off
// nothing happens at all: no config fetch, no import, no beacon.
import { whenWelcomeClosed } from "./onboarding-gate.js";

// A `let`, so esbuild neither bundles this import nor folds it into a literal import("...")
// (test/onboarding.test.mjs finds the welcome bundle as the app's first literal import).
let slotsUrl = __RVM.slotsJs; // eslint-disable-line prefer-const

export function initSlots(ctx) {
	let touched = false, loading = false;
	// Supporters see no ad cards at all (docs/SUPPORTERS.md 8), exactly as if "Show ads" were off.
	const on = () => ctx.get("adsEnabled") !== false && !noAdCards();
	const load = () => {
		if (loading || !touched || !on()) return;
		loading = true;
		whenWelcomeClosed(() => {
			if (!on()) { loading = false; return; }
			// The per-host config decides first, so a host with slots off never loads slot code.
			fetch("/__rv/slots", { credentials: "omit" })
				.then((r) => (r.ok ? r.json() : null))
				.catch(() => null)
				.then((conf) => {
					if (conf && conf.mode === "off") return;
					if (!on()) { loading = false; return; }
					return import(slotsUrl).then((m) => m.start(ctx, conf));
				})
				.catch(() => {});
		});
	};
	const first = () => { touched = true; evs.forEach((t) => removeEventListener(t, first, true)); load(); };
	const evs = ["pointerdown", "keydown", "touchstart"];
	evs.forEach((t) => addEventListener(t, first, { capture: true, passive: true }));
	ctx.subscribe(load); // turned back on later in this visit: load then (the module itself loads once)
}

// The no-ad-cards perk from this browser's copy of the supporter state, read the same way as
// shared/supporter.js cachedPerks() (kept inline so the app bundle doesn't carry that module):
// only a lifetime pass, or a pass whose grace period hasn't ended.
export function noAdCards(now = Date.now()) {
	try {
		const j = JSON.parse(localStorage.getItem("revault:supporter"));
		return !!(j && j.perks && j.perks.noAdCards === true && (j.status === "lifetime" || ((j.status === "active" || j.status === "grace") && j.graceUntil > now)));
	} catch (e) { void e; return false; }
}
